module.exports = __webpack_public_path__ + "static/media/Clock_Icon_Glowing@3x.b4ddc10a.png";